export const CRITICAL_ILLNESS = {
  isHidden: true,
  nickname: 'PRODUCTS.CRITICAL_ILLNESS.nickname',
  lifeInsurance: true,
  icon:'critical-illness'
};
